export default __webpack_public_path__ + "static/media/booth4.6de44436.png";